import type { SVGProps } from 'react';

interface SVGRProps {
  readonly title?: string;
  readonly titleId?: string;
}

const SvgIconOutlineAltitude = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={47}
    height={47}
    fill="none"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <rect
      width={46.33}
      height={46.33}
      x={0.33}
      y={0.33}
      stroke="#32353B"
      strokeOpacity={0.2}
      strokeWidth={0.667}
      rx={11.67}
    />
    <path
      fill="#32353B"
      d="M29 22v-4.2l-1.6 1.6L26 18l4-4 4 4-1.4 1.43-1.6-1.6V22zM12 32l6-8 4.5 6H30l-5-6.65-2.5 3.3L21.25 25 25 20l9 12z"
    />
  </svg>
);

export default SvgIconOutlineAltitude;
